<template>
  <div
    ref="observer"
    class="observer-element"
  />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop, Ref } from "vue-property-decorator"

type ObserverOptions = ConstructorParameters<typeof IntersectionObserver>[1]

@Options({
  name: "ObserverComponent"
})
export default class ObserverComponent extends Vue {
  @Prop() options: ObserverOptions
  @Prop({
    default: true
  })
  last: boolean

  @Ref("observer") readonly observerEl!: HTMLElement

  observer: IntersectionObserver

  mounted() {
    this.init()
  }

  beforeUnmount() {
    this.observer?.disconnect()
  }

  /** Reports sentinel visibility separately from the pagination-only intersect event. */
  init() {
    const options = this.options || {}
    this.observer = new IntersectionObserver(([entry]) => {
      this.$emit("visibilityChange", Boolean(entry?.isIntersecting))
      if (entry && entry.isIntersecting) {
        if (!this.last) {
          this.$emit("intersect")
        }
      }
    }, options)
    if (!this.observerEl) return
    this.$nextTick(() => {
      this.observer.observe(this.observerEl)
    })
  }
}
</script>
